import { apiMutate, isApiError } from "~/utils/apiClient";

const { VITE_ANALYSIS_AGENT_API } = import.meta.env;

export type FeedbackType = "BINARY" | "FIVE_POINT" | "TEXT";

export interface FeedbackCreate {
  feedback_type: FeedbackType;
  // 0/1 for BINARY, 1-5 for FIVE_POINT, null for TEXT
  feedback_value: number | null;
  text?: string | null;
  // 1-4 impact scale
  impact?: number | null;
}

export interface TurnFeedback extends FeedbackCreate {
  turn_id: string;
  created_at: string;
  updated_at: string;
}

const turnFeedbackPath = (conversationId: string, turnId: string) =>
  `${VITE_ANALYSIS_AGENT_API}/conversations/${conversationId}/turns/${turnId}/feedback`;

export async function putTurnFeedback(
  conversationId: string,
  turnId: string,
  feedback: FeedbackCreate
): Promise<TurnFeedback> {
  return apiMutate<TurnFeedback>(turnFeedbackPath(conversationId, turnId), "PUT", feedback);
}

// Idempotent: a 404 means feedback was already gone, which is a success.
export async function deleteTurnFeedback(conversationId: string, turnId: string): Promise<void> {
  try {
    await apiMutate(turnFeedbackPath(conversationId, turnId), "DELETE", undefined, {
      expects204: true,
    });
  } catch (error) {
    if (isApiError(error) && error.status === 404) return;
    throw error;
  }
}
